// extracted by mini-css-extract-plugin
export default {"titleHeader":"aWZDn8A1nrPFu_d0pG4H","preTitle":"iAl3MN_2DpA4XzZObdzK","postTitle":"yJJfa3jpmuyPRyBMZX8h","title":"Z2OKnln3rIdV1aehp_Ls"};